import React from 'react'
import PropTypes from 'prop-types'
import { FlatList } from 'react-native'
import NoAvailableData from './NoAvailableData'
import Spinner from '../Spinner'

const ListWithInfiniteScroll = ({ data, component: Component, noMore, handleLoadMore, loading, cardProps, noDataMessage, testID }) => {
  const loadMore = () => {
    !noMore && !loading && handleLoadMore()
  }
  return (
    (!data.length) ? (
      <NoAvailableData message={noDataMessage} />
    ) : (
      <FlatList
        contentContainerStyle={{ paddingHorizontal: 5 }}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        data={data}
        keyExtractor={(_, key) => key.toString()}
        renderItem={({ item }) => <Component item={item} {...cardProps} />}
        onEndReachedThreshold={0.5}
        onEndReached={loadMore}
        ListFooterComponent={loading && (
          <Spinner />
        )}
        testID={testID}
        accessibilityLabel={testID}
      />
    )
  )
}

ListWithInfiniteScroll.propTypes = {
  data: PropTypes.array.isRequired,
  component: PropTypes.any.isRequired,
  noMore: PropTypes.bool.isRequired,
  handleLoadMore: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  cardProps: PropTypes.object,
  noDataMessage: PropTypes.string,
  testID: PropTypes.string
}

export default ListWithInfiniteScroll
